export function mapMainAxisAlignment(alignment: string = "center"): string {
    return {
        start: "flex-start",
        end: "flex-end",
        center: "center",
        spaceBetween: "space-between",
        spaceAround: "space-around",
        spaceEvenly: "space-evenly",
    }[alignment] || "center";
}

export function mapCrossAxisAlignment(alignment: string = "stretch"): string {
    return {
        start: "flex-start",
        end: "flex-end",
        center: "center",
        stretch: "stretch",
    }[alignment] || "stretch";
}
